import * as yup from 'yup'

const REQUIRED_MESSAGE = 'This field is required'

export const As2ConnectionConfigModalSchema = yup.object({
  id: yup.number(),
  identifier: yup.string().required(REQUIRED_MESSAGE),
  outboundUrl: yup.string().url('Invalid URL format').required(REQUIRED_MESSAGE),
  serverInfoCredentialsIdentifier: yup.string().required(REQUIRED_MESSAGE),
  transfixIdentifier: yup.string().required(REQUIRED_MESSAGE),
})

export type TAs2ConnectionConfigModalSchema = yup.InferType<typeof As2ConnectionConfigModalSchema>
